'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuth(id, created, deleted, name, kind, payload) {
  this.jk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.LO = null;
  this.LP = null;
  this.l6 = null;
  this.qv = null;
  this.xL = null;
  this.jk = id;
  this.LO = created;
  this.LP = deleted;
  this.l6 = name;
  this.qv = kind;
  this.xL = payload;
}
export { $c_Lpresto_types$TwoFactorAuth as $c_Lpresto_types$TwoFactorAuth };
$p = $c_Lpresto_types$TwoFactorAuth.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuth;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuth() {
}
export { $h_Lpresto_types$TwoFactorAuth as $h_Lpresto_types$TwoFactorAuth };
$h_Lpresto_types$TwoFactorAuth.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("TwoFactorAuth"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.jk;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LO));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LP));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.l6));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.qv));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xL));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 6);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$TwoFactorAuth)) {
    var this$1 = this.jk;
    var b = x$0.jk;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var x = this.LO;
      var x$2 = x$0.LO;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.LP;
      var x$4 = x$0.LP;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.l6 === x$0.l6))) {
      var x$5 = this.qv;
      var x$6 = x$0.qv;
      var $x_1 = (x$5 === x$6);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.xL;
      var x$8 = x$0.xL;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "TwoFactorAuth";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.jk;
      break;
    }
    case 1: {
      return this.LO;
      break;
    }
    case 2: {
      return this.LP;
      break;
    }
    case 3: {
      return this.l6;
      break;
    }
    case 4: {
      return this.qv;
      break;
    }
    case 5: {
      return this.xL;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$TwoFactorAuth(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ko)));
}
export { $isArrayOf_Lpresto_types$TwoFactorAuth as $isArrayOf_Lpresto_types$TwoFactorAuth };
var $d_Lpresto_types$TwoFactorAuth = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuth, "presto.types$TwoFactorAuth", ({
  ko: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TwoFactorAuth as $d_Lpresto_types$TwoFactorAuth };
//# sourceMappingURL=presto.types$-Two-Factor-Auth.js.map
